<div class="modal-body">
  <p>
    Make sure that the account you're bootstrapping has MA license activated.
  </p>
  <div class="input-group mb-3">
    <input
      #accountId
      type="text"
      class="form-control"
      placeholder="AccountId"
      aria-label="AccountId"
      aria-describedby="basic-addon1"
    />
  </div>
  <div class="input-group mb-3">
    <input
      #sectionId
      type="text"
      class="form-control"
      placeholder="SectionId"
      aria-label="SectionId"
      aria-describedby="basic-addon1"
    />
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    data-dismiss="modal"
    (click)="activeModal.close()"
  >
    Close
  </button>
  <button
    #bootstrapButton
    type="button"
    class="btn btn-primary"
    (click)="bootstrap()"
  >
    {{ bootstrapButtonText$ | async }}
  </button>
</div>
